<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        title: string,
        subTitle: string,
        desc: string,
        mode?: 'navatel' | 'navaApp' | 'webchat'
    }>(),
    { mode: 'navatel' }
);
export type TOverviewMode = typeof props.mode;
</script>

<template>
    <SectionsBase 
        id="navatel-overview"
        class="bg-primary-50/40 bg-[url('/img/new/backgrounds/dashed-01.webp')] bg-no-repeat lg:bg-size-[100%_auto]"
    >
        <div class="container relative">
            <DevicesMobile>
                <ChipsDivider>عملکرد نواتل در یک نگاه</ChipsDivider>
            </DevicesMobile>

            <DevicesDesktop>
                <ChipsBase type="Secondary" variant="warning" class="mb-4 mt-10">عملکرد نواتل در یک نگاه</ChipsBase>
            </DevicesDesktop>

            <h2 class="lg:text-start">{{ props.title }}</h2>
            <span class="text-gray-500 text-center lg:text-start h3 block mt-4">{{ props.subTitle }}</span>
            <p class="text-body1-semibold text-gray-400 text-center lg:text-start my-6 lg:mt-10">{{ props.desc }}</p>

            <DevicesMobile>
                <NuxtImg
                    src="/img/new/navatel-overview.webp"
                    alt="عملکرد نواتل در یک نگاه"
                    loading="lazy"
                    class="w-full img-shadow"
                />
                <SectionsNavatelOverviewStats :mode />
            </DevicesMobile>

            <DevicesDesktop>
                <div class="relative z-1">
                    <SectionsNavatelOverviewStats :mode />
                </div>
                <NuxtImg
                    src="/img/new/navatel-overview.webp"
                    alt="عملکرد نواتل در یک نگاه"
                    loading="lazy"
                    class="absolute w-90 2xl:w-100 top-0 left-4 img-shadow"
                />
            </DevicesDesktop>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.img-shadow {
    filter:     
        drop-shadow(0px 5.39px 1.02px #0F08430B)
        drop-shadow(0px -14.9px 11.24px #4032AB0C)
        drop-shadow(0px -35.88px 48.08px #3624B80C)
        drop-shadow(0px 119px 80px #3826C112);
}
</style>